<div class="stocktake-items-tabbed-grid data-grid-container">
    <app-generic-data-grid #stocktakeItemsListTabbedDataGrid 
        [dataSourceConfig]="stocktakeItemsListDataSourceConfig"
        [joinTableColumnConfig]="stocktakeItemsJoinTableColumnConfig" 
        [dataGridConfig]="stocktakeItemsListDataGridConfig"
        [dataGridActionColumn]="stocktakeItemsListDataGridActionColumn">
    </app-generic-data-grid>
</div>